import { render, staticRenderFns } from "./Cuentasbancarias.vue?vue&type=template&id=6819c55a&"
import script from "./Cuentasbancarias.vue?vue&type=script&lang=ts&"
export * from "./Cuentasbancarias.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports